import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { ScrollView } from "react-native-gesture-handler";
import React from 'react';
import i18n from "i18n-js";
import {useSelector} from "react-redux";
import app from "../../app.json";
import {Linking} from "react-native";
import PressableElement from "../../components/basic/PressableElement";
import {useSafeAreaInsets} from "react-native-safe-area-context";
import BasicButton from '../../components/basic/BasicButton';
import { switchScreen } from '../../hooks/navigate';

export default function HelpScreen({navigation}) {
    const user = useSelector((state) => state.user) || {name: 'Unkown', demo: true}
    const insets = useSafeAreaInsets()

    return (
        <View className="flex-1 bg-secondary-50">
            <ScrollView scrollIndicatorInsets={{ right: 1 }} contentContainerStyle={{ paddingBottom: 90 + insets.bottom }} className="flex-1 bg-secondary-50 py-3 px-3">
                <VStack space='2xl' className="flex-1 bg-secondary-50">
                    <VStack space='xl' className="flex-1 pb-1">
                        <Text className="text-2xl text-secondary-900">{i18n.t('helpScreen.supportContact')}</Text>
                        <PressableElement mainText={i18n.t('helpScreen.website')} secondaryText='ina.coach' pressed={() => Linking.openURL('https://ina.coach/')} />
                        <PressableElement mainText={i18n.t('helpScreen.email')} secondaryText='hallo@ina.coach' pressed={() => Linking.openURL('mailto:hallo@ina.coach')} />
                        <PressableElement mainText={i18n.t('helpScreen.tel')} secondaryText={'+4971719789988'} pressed={() => Linking.openURL('tel:+4971719789988')} />
                        <Text className="text-xl px-3 text-secondary-900">
                            {i18n.t('helpScreen.helperText1')}
                            {user.demo ? i18n.t('helpScreen.helperText1Demo') : i18n.t('helpScreen.helperText1User')}
                            {!user.demo && <Text className="text-xl text-primary-900">
                                {user.mail ? ' ' + user.mail : ''}
                            </Text>}
                            {i18n.t('helpScreen.helperText2')}
                            <Text className="text-xl text-primary-900">
                                {'v' + app.expo.version}
                            </Text>
                            {i18n.t('helpScreen.helperText3')}
                        </Text>
                    </VStack>
                    <BasicButton flex={1} onPress={() => switchScreen(navigation, 'MainStack', {screen: 'Tutorial'})} text={i18n.t('tutorial.title')} />
                </VStack>
            </ScrollView>
        </View>
    );
}
